// page-recruit.jsx — 採用情報 (Recruit / 私たちの秘密基地)
// Issue #37 [HP改修] 採用情報トップページ（/recruit/）再構成 に準拠。
// データソース: HR Report 2026 (Canva)
// セクション順: HERO → CEO MESSAGE → COMPANY（抜粋）→ OPEN POSITIONS → END CTA
// 沿革・数値・メンバー・行動原則・オフィスは /recruit/company/ に移設した（PR #134）。
// 同じ内容を 2 ページに出さないため、ここには抜粋と導線だけを置く。

(function(){
  const { HBLayout, HBSubHero, hbcp, fontEN, fontENSans, fontJP, fontMono, HB_BASE, HB_WANTEDLY } = window;

  // variant-d.jsx の HOME_POSITIONS を window.HB_POSITIONS 経由で受け取る (FALLBACK 含む)
  // 但し issue #37 の "OPEN POSITIONS" は専用の 4 ポジション固定リスト。
  // 一方で variant-d 側に増減があれば反映できるよう、両方表示できる形にしておく。
  const POSITIONS = [
    { idx:'01', dept:'会計事業部',                   role:'freee会計や勘定奉行の導入支援',         type:'正社員 / 業務委託',          loc:'フルリモート可・未経験OK',
      d:'会計事業部の中心メンバーとして、クライアントの会計データを freee 会計へ移行していく役割をまるっとお任せします。' },
    { idx:'02', dept:'DX事業部',                      role:'会計特化 DX コンサルタント',              type:'正社員 / 業務委託',          loc:'経験者優遇',
      d:'会計ソフト導入にかかる知見を活かしつつ、kintone や Salesforce を活用した DX 化の推進をお願いします。' },
    { idx:'03', dept:'会計事業部',                   role:'労務コンサルタント',                       type:'正社員 / 業務委託',          loc:'フルリモート可・経験者優遇',
      d:'freee 人事労務の導入、顧客への労務関連の対応、コンサルティングをお願いしております。' },
    { idx:'04', dept:'はてなベース税理士法人',  role:'freee 記帳・申告スタッフ',                 type:'正社員 / パート / 業務委託', loc:'フルリモート可・経験者優遇',
      d:'freee 会計と freee 申告を駆使して税務顧問先の顧客対応・記帳代行・税務申告サポートをいただきます。' },
  ];


  // 数値データ (HR Report P10)
  const DATA_BASIC = [
    { en:'FOUNDED',          jp:'創業',         v:'2023.02', sub:'設立 3 年' },
    { en:'EMPLOYEES',        jp:'従業員数',     v:'55',      sub:'人 (含 業務委託)' },
    { en:'AVG. AGE',         jp:'平均年齢',     v:'26.5',    sub:'歳' },
    { en:'FULL-TIME',        jp:'正社員数',     v:'2',       sub:'人' },
    { en:'YOY GROWTH',       jp:'前年比成長率', v:'163',     sub:'%' },
  ];


  // チームメンバー (P8)



  const RECRUIT_RESPONSIVE_CSS = `
    @media (max-width: 900px) {
      .hb-r-section { padding: 64px 20px !important; }
      .hb-r-grid-2 { grid-template-columns: 1fr !important; gap: 24px !important; }
      .hb-r-grid-3 { grid-template-columns: 1fr !important; gap: 24px !important; }
      .hb-r-grid-team { grid-template-columns: 1fr !important; gap: 16px !important; }
      .hb-r-team-card { grid-template-columns: 120px 1fr !important; gap: 16px !important; padding: 16px !important; }
      .hb-r-ceo { grid-template-columns: 1fr !important; gap: 32px !important; }
      .hb-r-office-wide { grid-template-columns: 1fr !important; gap: 12px !important; }
      .hb-r-end { grid-template-columns: 1fr !important; gap: 32px !important; }
    }
    @media (max-width: 720px) {
      .hb-r-section { padding: 48px 16px !important; }
      .hb-r-grid-5 { grid-template-columns: repeat(2, 1fr) !important; gap: 10px !important; }
      .hb-r-grid-5 > * { padding: 16px 14px !important; }
      .hb-r-grid-qualify { grid-template-columns: repeat(2, 1fr) !important; gap: 14px 18px !important; }
      .hb-r-grid-qualify > * { border-right: none !important; padding-right: 0 !important; }
      .hb-r-grid-4 { grid-template-columns: repeat(2, 1fr) !important; gap: 12px !important; }
      .hb-r-pie-legend { grid-template-columns: 1fr !important; gap: 18px !important; }
      .hb-r-team-card { grid-template-columns: 1fr !important; gap: 12px !important; }
      .hb-r-team-card > div:first-child { max-width: 200px; }
      /* OPEN POSITIONS — 5 列固定を auto/1fr の 3 行に組み替え */
      .hb-r-pos-row { grid-template-columns: auto 1fr !important; grid-template-rows: auto auto auto !important;
        column-gap: 12px !important; row-gap: 6px !important; padding: 18px 14px !important; }
      .hb-r-pos-row > *:nth-child(1) { grid-row: 1; grid-column: 1; font-size: 22px !important; }
      .hb-r-pos-row > *:nth-child(2) { grid-row: 1; grid-column: 2; align-self: center; }
      .hb-r-pos-row > *:nth-child(3) { grid-row: 2; grid-column: 1 / -1; }
      .hb-r-pos-row > *:nth-child(4) { grid-row: 3; grid-column: 1 / -1; padding-top: 6px; border-top: 1px dashed #E2DACB; }
      .hb-r-pos-row > *:nth-child(5) { display: none !important; }
      /* HERO 内ロングテキストと見出しの縮小 */
      h2.hb-r-h2-md { font-size: 22px !important; }
      /* History を縦積みタイムラインに組み替え。
         variant-d-loader の [style*="160px 1fr"] (specificity 0,1,1) を
         二重クラスで上書きし、date 行は小さい青ラベル、body 行は本文として表示。
         vertical line は consumer の認知負荷が増えるだけなので mobile では消す。 */
      .hb-r-history.hb-r-history { grid-template-columns: 1fr !important; gap: 0 !important; }
      .hb-r-history-line { display: none !important; }
      .hb-r-history-dot { display: none !important; }
      .hb-r-history-date { text-align: left !important; padding: 14px 0 0 !important; }
      .hb-r-history-body { padding: 4px 0 14px 0 !important; }
    }
  `;

  function RecruitPage() {
    return (
      <HBLayout>
        <style>{RECRUIT_RESPONSIVE_CSS}</style>
        {/* ───── 1. HERO ───── */}
        <HBSubHero
          crumb={`Recruit / 採用情報`}
          en="Recruit"
          bgImage={(window.HB_ASSETS||'')+"images/recruit/recruit-hero-bg.jpg"}
          jp={<span><span style={{color:hbcp.blue}}>ちょっと無茶</span>な変化球すら打ち返す、<br/>知る人ぞ知るバックオフィスのよろずや</span>}
          tag={'A hideout for one-of-a-kind talents.'}
          lead={'会社名「はてなベース」は、コーポレート領域において経営者が抱える分からないこと（はてな）を、一芸を持った少数精鋭チームで解決する秘密基地（ベースキャンプ）をイメージして名付けられました。知る人ぞ知るバックオフィスのよろずやとして、専門領域を翻訳しながら、自分の手で動かせる仲間を募集しています。'}
        />

        {/* ───── 2. CEO MESSAGE ───── */}
        <section className="hb-r-section" style={{padding:'96px 32px', background:hbcp.white, borderBottom:`1px solid ${hbcp.line}`}}>
          <div style={{maxWidth:1280, margin:'0 auto'}}>
            <div className="hb-section-head">
              <span className="hb-section-head-en">CEO Message</span>
              <span className="hb-section-head-jp">代表メッセージ</span>
            </div>
            <h2 className="hb-r-h2-md" style={{fontFamily:fontJP, fontWeight:900, fontSize:'clamp(26px, 3vw, 36px)', lineHeight:1.4, letterSpacing:'.04em', margin:'0 0 32px', color:hbcp.ink, maxWidth:880}}>
              唯一無二のスキルを発揮できる<br/>秘密基地の一員に。
            </h2>
            <div className="hb-r-ceo" style={{display:'grid', gridTemplateColumns:'1fr 420px', gap:64, alignItems:'flex-start'}}>
              <div>
                <p style={{fontSize:15, lineHeight:2, color:hbcp.inkSoft, margin:'0 0 16px'}}>
                  大学受験の失敗をきっかけに、大学 1 年生で挑戦した公認会計士試験。2019 年に論文式試験に合格し、そこから 7 年。「困ったらワクワクする方向へ全力で走れ」という父の言葉を信じ、監査法人、ベンチャー企業、そして起業と、がむしゃらに突き進んできました。その結果、定石から外れながらも、29 歳の今があります。
                </p>
                <p style={{fontSize:15, lineHeight:2, color:hbcp.inkSoft, margin:'0 0 16px'}}>
                  はてなベースは、私のように少し道を逸れた仲間たちが集まり生まれた場所です。メンバーは、皆「ちょっと変わった人たち」。一般常識の枠を超えた個性や能力を持つ人々が、それを最大限に発揮できる秘密基地です。
                </p>
                <p style={{fontSize:15, lineHeight:2, color:hbcp.inkSoft, margin:'0 0 32px'}}>
                  ここでは、好きなことや得意なことを武器に、あなたにしかない「唯一無二の刀」を研ぎ澄ますことができます。私たちと一緒に、その可能性を広げていきましょう。
                </p>
                <div style={{display:'flex', alignItems:'center', gap:14, paddingTop:18, borderTop:`1px solid ${hbcp.line}`}}>
                  <div>
                    <div style={{fontFamily:fontENSans, fontSize:11, letterSpacing:'.18em', color:hbcp.blue, fontWeight:600, marginBottom:4}}>CEO / FOUNDER</div>
                    <div style={{fontFamily:fontJP, fontWeight:700, fontSize:18}}>代表取締役 世戸口 逸人</div>
                  </div>
                </div>
              </div>
              <aside>
                <div style={{aspectRatio:'1/1', overflow:'hidden', background:hbcp.paper, border:`1px solid ${hbcp.line}`}}>
                  <img src={(window.HB_ASSETS||'')+"images/wantedly/ceo-setoguchi.jpg?v=20260708"} alt="代表取締役 世戸口逸人" style={{width:'100%', height:'100%', objectFit:'cover', objectPosition:'top center', display:'block'}}/>
                </div>
                <div style={{marginTop:14, fontFamily:fontMono, fontSize:11, lineHeight:1.85, color:hbcp.inkLight}}>
                  HQ — 東京都新宿区愛住町 23-1<br/>woody21 6 階
                </div>
              </aside>
            </div>
          </div>
        </section>

        {/* ───── 3. COMPANY（抜粋 → /recruit/company/ ） ─────
             沿革・数値・メンバー・行動原則・オフィスは /recruit/company/ に移した。
             ここは抜粋だけを置き、同じ内容が 2 ページに出ないようにする。 */}
        <section className="hb-r-section" style={{padding:'96px 32px', background:hbcp.paper, borderBottom:`1px solid ${hbcp.line}`}}>
          <div style={{maxWidth:1280, margin:'0 auto'}}>
            <div className="hb-section-head">
              <span className="hb-section-head-en">Company</span>
              <span className="hb-section-head-jp">会社を知る</span>
            </div>
            <p style={{fontSize:14, lineHeight:1.95, color:hbcp.inkSoft, margin:'0 0 36px', maxWidth:680}}>
              2023 年 2 月の創業から、3 年で 55 名規模・3 拠点・複数の事業ラインへ。沿革・人数の内訳・行動原則・オフィスは、会社ページにまとめています。
            </p>

            <div className="hb-r-grid-5" style={{display:'grid', gridTemplateColumns:'repeat(4, 1fr)', gap:16, marginBottom:36}}>
              {DATA_BASIC.filter( d => d.en !== 'YOY GROWTH' ).map( d => (
                <div key={d.en} style={{padding:'24px 22px', background:'#fff', border:`1px solid ${hbcp.line}`, borderTop:`3px solid ${hbcp.blue}`}}>
                  <div style={{fontFamily:fontENSans, fontSize:9.5, letterSpacing:'.28em', color:hbcp.blue, fontWeight:700, marginBottom:6}}>{d.en}</div>
                  <div style={{fontFamily:fontJP, fontSize:11, color:hbcp.inkLight, marginBottom:14}}>{d.jp}</div>
                  <div style={{fontFamily:fontEN, fontWeight:300, fontSize:'clamp(34px, 3vw, 44px)', lineHeight:1, color:hbcp.ink}}>{d.v}</div>
                  <div style={{fontFamily:fontJP, fontSize:11, color:hbcp.inkLight, marginTop:6}}>{d.sub}</div>
                </div>
              ))}
            </div>

            <p style={{fontFamily:fontJP, fontSize:13, lineHeight:1.95, color:hbcp.inkSoft, margin:'0 0 24px'}}>
              会社ページに載せているもの: 沿革の年表 ／ 年齢・事業部・職種・男女の内訳 ／ チームメンバーの紹介 ／ 行動原則 ／ オフィスと働く環境
            </p>

            <a href={`${HB_BASE}/recruit/company/`} style={{display:'inline-flex', alignItems:'center', gap:10, padding:'14px 26px', background:hbcp.blue, color:'#fff', textDecoration:'none', fontFamily:fontJP, fontSize:14, fontWeight:700}}>
              会社を知る <span style={{fontFamily:fontEN}}>→</span>
            </a>
          </div>
        </section>


        {/* ───── 9. OPEN POSITIONS ───── */}
        <section className="hb-r-section" style={{padding:'96px 32px', background:hbcp.paper, borderBottom:`1px solid ${hbcp.line}`}}>
          <div style={{maxWidth:1280, margin:'0 auto'}}>
            <div className="hb-section-head">
              <span className="hb-section-head-en">Open Positions</span>
              <span className="hb-section-head-jp">募集職種</span>
              <span style={{marginLeft:'auto', fontFamily:fontMono, fontSize:11, color:hbcp.inkLight}}>{POSITIONS.length} ROLES</span>
            </div>
            <div style={{borderTop:`1px solid ${hbcp.ink}`, marginTop:14}}>
              {POSITIONS.map( p => (
                <a key={p.idx} href={HB_WANTEDLY} target="_blank" rel="noopener" className="hb-r-pos-row" style={{display:'grid', gridTemplateColumns:'48px 140px 1fr 200px 32px', gap:24, alignItems:'center', padding:'22px 12px', borderBottom:`1px solid ${hbcp.line}`, textDecoration:'none', color:hbcp.ink, background:'#fff'}}>
                  <span style={{fontFamily:fontEN, fontWeight:300, fontSize:28, color:hbcp.blue, lineHeight:1}}>{p.idx}</span>
                  <span style={{fontFamily:fontJP, fontSize:11, fontWeight:700, color:hbcp.blue, letterSpacing:'.04em'}}>{p.dept}</span>
                  <div>
                    <div style={{fontFamily:fontJP, fontWeight:700, fontSize:16, marginBottom:4, letterSpacing:'.04em'}}>{p.role}</div>
                    <div style={{fontFamily:fontJP, fontSize:12, color:hbcp.inkSoft, lineHeight:1.7, display:'-webkit-box', WebkitLineClamp:2, WebkitBoxOrient:'vertical', overflow:'hidden'}}>{p.d}</div>
                  </div>
                  <div>
                    <div style={{fontFamily:fontJP, fontSize:11, color:hbcp.inkSoft, marginBottom:3}}>{p.type}</div>
                    <div style={{fontFamily:fontJP, fontSize:11, color:hbcp.inkLight}}>{p.loc}</div>
                  </div>
                  <span style={{fontFamily:fontEN, fontSize:18, color:hbcp.blue}}>↗</span>
                </a>
              ))}
            </div>
            <div style={{marginTop:32, display:'flex', flexWrap:'wrap', gap:14}}>
              <a href={`${HB_BASE}/recruit/positions/`} style={{padding:'14px 26px', background:hbcp.blue, color:'#fff', textDecoration:'none', fontFamily:fontJP, fontSize:14, fontWeight:700}}>
                募集職種の一覧を見る <span style={{fontFamily:fontEN}}>→</span>
              </a>
              <a href={HB_WANTEDLY} target="_blank" rel="noopener" style={{padding:'14px 26px', background:'transparent', color:hbcp.ink, border:`1px solid ${hbcp.ink}`, textDecoration:'none', fontFamily:fontJP, fontSize:14, fontWeight:600}}>
                Wantedly で詳しく見る <span style={{fontFamily:fontEN}}>↗</span>
              </a>
              <a href={`${HB_WANTEDLY}/projects`} target="_blank" rel="noopener" style={{padding:'14px 26px', background:'transparent', color:hbcp.ink, border:`1px solid ${hbcp.ink}`, textDecoration:'none', fontFamily:fontJP, fontSize:14, fontWeight:600}}>
                新卒・インターン採用 <span style={{fontFamily:fontEN}}>↗</span>
              </a>
              <a href={`${HB_BASE}/contact`} style={{padding:'14px 26px', background:'transparent', color:hbcp.ink, border:`1px solid ${hbcp.ink}`, textDecoration:'none', fontFamily:fontJP, fontSize:14, fontWeight:600}}>
                カジュアル面談を申し込む <span style={{fontFamily:fontEN}}>↗</span>
              </a>
            </div>
          </div>
        </section>

        {/* ───── 10. END CTA (ダーク) ───── */}
        <section className="hb-r-section" style={{padding:'96px 32px', background:hbcp.ink, color:'#fff', position:'relative', overflow:'hidden'}}>
          <div className="hb-r-end" style={{position:'relative', maxWidth:1280, margin:'0 auto', display:'grid', gridTemplateColumns:'1.4fr 1fr', gap:64, alignItems:'flex-end'}}>
            <div>
              <div style={{fontFamily:fontENSans, fontSize:11, letterSpacing:'.32em', opacity:.85, marginBottom:18, color:hbcp.blueLight}}>● JOIN US</div>
              <h2 style={{fontFamily:fontJP, fontWeight:900, fontSize:'clamp(34px, 4.2vw, 50px)', lineHeight:1.4, margin:'0 0 24px'}}>
                私たちと<br/>一緒に働きませんか？
              </h2>
              <p style={{fontSize:15, lineHeight:1.95, opacity:.9, margin:0, maxWidth:540}}>
                少しでも興味を持っていただいたら、まずはカジュアル面談から。あなたの「一芸」が活きる場所が、ここにあります。
              </p>
            </div>
            <div style={{display:'grid', gap:14}}>
              <a href={`${HB_BASE}/contact`} style={{padding:'18px 28px', background:'#fff', color:hbcp.ink, textDecoration:'none', fontFamily:fontJP, fontSize:15, fontWeight:700, display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                <span>お問い合わせ</span><span style={{fontFamily:fontEN}}>→</span>
              </a>
              <a href={HB_WANTEDLY} target="_blank" rel="noopener" style={{padding:'18px 28px', background:'transparent', color:'#fff', border:'1px solid rgba(255,255,255,.6)', textDecoration:'none', fontFamily:fontJP, fontSize:15, fontWeight:600, display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                <span>Wantedly で詳しく見る</span><span style={{fontFamily:fontEN}}>↗</span>
              </a>
            </div>
          </div>
        </section>
      </HBLayout>
    );
  }

  Object.assign(window, { RecruitPage });
})();
